import React from "react";

import { Box, Flex, Link, Loading, Text } from "src/components";
import { Button } from "src/components/Form";

import { defaultPrevented } from "src/utils";

const DeleteConfirmation = ({
  title,
  deleteLabel = "Yes, delete it",
  loadingLabel,
  loading,
  cancelLabel = "No, I changed my mind",
  description,
  onCancel,
  onConfirm,
}) => {
  return (
    <Box p={2} maxWidth={350}>
      {loadingLabel && loading ? (
        <Text color="muted" fontSize={3} fontWeight="bold">
          {loadingLabel}
        </Text>
      ) : (
        <Text color="alert" fontSize={3} fontWeight="bold">
          {title}
        </Text>
      )}

      {description ? (
        <Box mt={2} mb={2}>
          <Text fontSize={2}>{description}</Text>
        </Box>
      ) : null}

      <Flex flexDirection="column" mt={2} align="center">
        <Button
          p={3}
          title={deleteLabel}
          alignSelf="stretch"
          type="button"
          bg="alert"
          disabled={loading}
          style={{
            opacity: loading ? 0.5 : 1,
          }}
          onClick={onConfirm}
        />

        <Link
          to="#"
          onClick={defaultPrevented(onCancel)}
          color="muted"
          disabled={loading}
          mt={2}
        >
          {cancelLabel}
        </Link>
      </Flex>
    </Box>
  );
};

export default DeleteConfirmation;



// WEBPACK FOOTER //
// ./src/banking/components/DeleteConfirmation.js